import { reactive, watch, onMounted } from "vue";

export function useScreenReader() {
    const state = reactive({
        isScreenReaderActive: false,
        currentLang: "fr",
    });

    let screenReader = null;
    const synth = window.speechSynthesis;

    function manageScreenReader() {
        if (!screenReader) {
            screenReader = new window.SpeechSynthesisUtterance();
            setVoiceForLanguage(state.currentLang);
        }

        const tags = document.querySelectorAll("a,button,p,h1,h2,h3");
        if (state.isScreenReaderActive) {
            tags.forEach((tag) => {
                tag.classList.add("screenReaderItem");
                tag.addEventListener("click", readText, true);
            });
        } else {
            tags.forEach((tag) => {
                tag.classList.remove("screenReaderItem");
                tag.removeEventListener("click", readText, true);
            });
        }
    }

    function setVoiceForLanguage(langCode) {
        if (!screenReader) return;

        const target = langCode.toLowerCase();
        const voices = synth.getVoices();

        let chosenVoice = voices.find(
            (v) => v.name.includes("Google") && v.lang.toLowerCase().startsWith(target)
        );
        if (!chosenVoice) {
            chosenVoice = voices.find((v) => v.lang.toLowerCase().startsWith(target));
        }
        if (!chosenVoice && target === "fr") {
            chosenVoice =
                voices.find((v) => v.name === "Amélie") ||
                voices.find((v) => v.lang.toLowerCase().startsWith("fr"));
        }

        if (chosenVoice) {
            screenReader.voice = chosenVoice;
            screenReader.lang = chosenVoice.lang;
        }
    }

    function readText(e) {
        e.preventDefault();
        e.stopPropagation();
        screenReader.text = e.target.innerText;
        e.target.classList.add("active");
        synth.speak(screenReader);
        const interval = setInterval(() => {
            if (!synth.speaking) {
                e.target.classList.remove("active");
                clearInterval(interval);
            }
        }, 100);
    }

    function reset() {
        state.isScreenReaderActive = false;
    }

    function applyFromProfile(entry) {
        if (entry.isScreenReaderActive) {
            state.isScreenReaderActive = true;
        }
    }

    watch(
        () => state.isScreenReaderActive,
        () => manageScreenReader()
    );

    onMounted(() => {
        if (window.speechSynthesis.onvoiceschanged !== undefined) {
            window.speechSynthesis.onvoiceschanged = () => {
                setVoiceForLanguage(state.currentLang);
            };
        }
    });

    return { state, manageScreenReader, setVoiceForLanguage, readText, reset, applyFromProfile };
}
